import { isNotDefined } from '@sgme/fp';
import clsx from 'clsx';
import { use } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import {
  TargetAccumulatorContext,
  useTargetAccumulatorSelector,
} from '@/App/tiles/TargetAccumulator/TargetAccumulatorContext.tsx';
import { useAppSelector } from '@/store/hooks.ts';
import {
  getTargetAccumulatorIsEligibleToPremiumRateStoMid,
  getTargetAccumulatorMarketData,
  selectTargetAccumulatorCurrencyData,
} from '@/store/targetAccumulator/selectors.ts';

export const PremiumGappedCcy = () => {
  const { formatNumber } = useIntl();
  const { tileId } = use(TargetAccumulatorContext);
  const { notionalCurrencyIndex, currency } = useAppSelector((state) =>
    selectTargetAccumulatorCurrencyData(state, tileId),
  );
  const marketData = useTargetAccumulatorSelector((targetAccumulator) =>
    getTargetAccumulatorMarketData(targetAccumulator),
  );
  const isEligibleToPremiumRateStoMid = useTargetAccumulatorSelector((targetAccumulator) =>
    getTargetAccumulatorIsEligibleToPremiumRateStoMid(targetAccumulator),
  );

  const { isExpired, accuType } = useTargetAccumulatorSelector((targetAccumulator) => {
    return {
      isExpired: targetAccumulator.properties.rfs.status === 'EXPIRED',
      accuType: targetAccumulator.properties.accuType,
    };
  });

  if (
    isNotDefined(notionalCurrencyIndex) ||
    !isEligibleToPremiumRateStoMid ||
    accuType === 'PIVOT' ||
    accuType === 'PIVOTEKI'
  ) {
    return null;
  }

  const premiumGappedCcy = marketData?.premiumGappedCcy[notionalCurrencyIndex - 1];

  return (
    <div
      className={clsx('form-group form-group-sm d-flex my-1', {
        expired: isExpired,
      })}
    >
      <div className="pe-1 col-form-label col-form-label-sm col-4 text-nowrap text-end" style={{ width: '30%' }}>
        <FormattedMessage id="accumulator.fields.premiumGappedCcy" />
      </div>
      {premiumGappedCcy && (
        <span className="d-flex flex-column px-1 fs-6" style={{ width: '64%' }} data-e2e="PremiumGappedCcy">
          {formatNumber(premiumGappedCcy, {
            maximumFractionDigits: 0,
            minimumFractionDigits: 0,
          })}{' '}
          {currency}
        </span>
      )}
    </div>
  );
};

export default PremiumGappedCcy;
